import { call } from 'redux-saga/effects';
import { RTCClient } from 'utils/webrtc';

export function* onConnectionEstablishedSaga() {
  yield call(RTCClient.attemptPublish);
}
